<template>
    <div>
        <el-dialog
            title="报名用户查看"
            :visible.sync="showdialog"
            width="900px"
            @close="back">
            <div class="base-warp">
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="头像" align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="用户姓名"></el-table-column>
                        <el-table-column prop="telephone" label="手机"></el-table-column>
                        <el-table-column prop="addDate" label="报名时间"></el-table-column>
                        <el-table-column prop="signin" label="签到"></el-table-column>
                    </el-table>
                </div>
                <el-row :gutter="20">
                    <el-col class="foot flex-box" :span="12" :offset="0">
                            <div class="foot-add" v-if="clients.length>0">
                                <span class="text">已识别到{{clients.length}}条数据</span>
                                <el-button type="success" size="mini" @click="addclients">立即上传</el-button>
                            </div>
                            <el-upload
                                class="upload-demo"
                                accept=".xls,.xlsx"
                                action=""
                                ref="upload"
                                :limit="5"
                                :on-change="upload"
                                :auto-upload="false"
                                :show-file-list="false">
                                <el-button class="btn" slot="trigger" size="mini" type="primary">导入客户</el-button>
                            </el-upload>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-pagination class="page-tion"
                            @current-change="currentChange"
                            layout="prev, pager, next"
                            :page-size="pagesize"
                            :total="total" background>
                        </el-pagination>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        
        
    </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
    data() {
        return {
            showdialog: true,
            tableData: [],
            pageNo: 1,
            pagesize: 8,
            total: 0,
            id: '',
            clients: [],
            ii: 0,
            timmer: '',
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.getTableData();
    },
    methods: {
        addclients() {
            this.ii = 0;
            this.timmer = setInterval(()=>{
                if (this.ii>=this.clients.length-1) clearInterval(this.timmer);
                var client = this.clients[this.ii];
                var params = {
                    id: this.id,
                    name: client.name,
                    telephone: client.telephone,
                    projectname: '',
                    projectid: '',
                }
                this.$api.adminactivityaddclient(params)
                    .then(
                        data=>{
                            this.$message.success(data);
                        }
                    )
                    this.ii++;
            }, 200)

        },
        getTableData() {
            var params = {
                id: this.id,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getActivityApplyList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        back() {
            this.$router.go(-1);
        },
        upload(file) {
            let files = {0:file.raw}
            this.readExcel1(files);
        },
        formateData(ws) {
            if (typeof ws !='object'){
                this.$Message.success('数据类型错误')
                return;
            }
            var clients = [];
            for (var user of ws){
                var obj  ={
                    name: user['姓名'],
                    telephone: user['联系方式'],
                }
                clients.push(obj)
            }
            this.clients = clients;
        },
        readExcel1(files) {//表格导入
            // console.log(files);
            if(files.length<=0){//如果没有文件名
                return false;
            }else if(!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())){
                this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
                return false;
            }
    
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        type: 'binary'
                    });
                    const wsname = workbook.SheetNames[0];//取第一张表
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
                    // console.log(ws);
                    this.formateData(ws);

                    this.$refs.upload.value = '';
                } catch (e) {
                    return false;
                }
            };
            fileReader.readAsBinaryString(files[0]);
        },
    },
}
</script>

<style lang="scss" scoped>
.foot{
    overflow: hidden;
    margin-top: 10px;
}
.foot-add{
    width: 100%;
    padding-right: 50px;
}
</style>